export { default as useMaterialsIndexPageSelectedMaterials } from './useMaterialsIndexPageSelectedMaterials';
